module.exports = __webpack_public_path__ + "fonts/Averta-Bold.1c2fa97.ttf";